import { useCallback, useState } from 'react'

const useUserValidation = ({
    onValid = () => {},
    user,
}) => {
    const [ error, setError ] = useState()
    const validateUser = useCallback(() => {
        console.log('Valdating...')
        if (!user.email) {
            setError('Email is required')
            return
        }
        if (!user.firstName || !user.lastName) {
            setError('Name is required')
            return
        }
        console.log('validated!')
        setError()
        onValid()
    }, [onValid, setError, user])

    return {
        validateUser,
        error
    }
}

export default useUserValidation